import { useMemo } from 'react';

declare global {
  interface Window {
    BOAT_TRADER_STATIC_CONTENT?: string;
  }
}

export default function StaticPageContent() {
  const html = useMemo(() => window.BOAT_TRADER_STATIC_CONTENT || '', []);
  if (!html) return null;
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
